import { IconAlertTriangleFilled } from '@tabler/icons-react';
import { FC } from 'react';

/** Shown on profile section headers while editing incomplete required fields. */
const ProfileRequiredBadge: FC = () => (
  <div className="ml-2 flex items-center" role="status">
    <IconAlertTriangleFilled
      className="text-status-warning-icon"
      size={18}
      aria-hidden="true"
    />
    <span className="ml-1.5 text-sm font-medium text-status-warning-text">
      Required
    </span>
  </div>
);

export default ProfileRequiredBadge;
